import * as CurrentPatientActions from '../actions/current-patient-actions.ts';
import * as NotificationsActions from '../actions/notifications-actions';
import * as OfferingActions from '../actions/offering-actions';
import * as PatientsActions from '../actions/patients-actions.ts';
import * as ReasonFormActions from '../../ng2/main/reasons/reason-form/reason-form.actions';
import * as ReasonsActions from '../../ng2/main/reasons/reasons.actions.ts';
import * as SessionActions from '../actions/session-actions.ts';

module.exports = class SessionService {

  static $inject = [
    '$http',
    '$ngRedux',
    '$state',
    '$local',
    'Session',
  ];

  constructor(
    $http,
    $ngRedux,
    $state,
    $local,
    Session,
  ) {
    this.$http = $http;
    this.$ngRedux = $ngRedux;
    this.$state = $state;
    this.$local = $local;
    this.Session = Session;

    this.setStateConnection();
  }

  setStateConnection() {
    this.$ngRedux.connect(state => ({
      session: state.session,
    }), Object.assign({}, CurrentPatientActions, NotificationsActions, OfferingActions, PatientsActions, ReasonFormActions, ReasonsActions, SessionActions))(this);
  }

  store(session) {
    this.$local.set('accountMode', session.account != null);

    this.setSession(session);
  }

  isAccountLoggedIn() {
    return this.$local.get('accountMode');
  }

  isPatientLoggedIn() {
    return this.fetch().authenticatedPatientId != null;
  }

  isInitialized() {
    return !!(this.fetch().groups && this.fetch().groups.length);
  }

  reset() {
    this.resetSession();
    this.unsetPatient();
    this.unsetNotifications();
    this.resetOffering();
    this.resetPatients();

    this.$local.remove('accountMode');

    this.$ngRedux.dispatch(new ReasonsActions.UnsetCurrentReason());
    this.$ngRedux.dispatch(new ReasonsActions.ResetReasons());
    this.$ngRedux.dispatch(new ReasonFormActions.ResetForm());
  }

  fetch() {
    return this.session;
  }

  load() {
    if (this.isAccountLoggedIn()) {
      return this.$http.get('/api/v2/session').then((response) => {
        this.store(response.data);
        return response;
      });
    }

    return this.Session.get({}).$promise.then((response) => {
      this.store(response);
      return response;
    });
  }

  updatePassword(password, resetToken) {
    if (resetToken) {
      return this.$http.put('/api/v2/patients/new_password', { reset_token: resetToken, new_password: password });
    }

    return this.$http.put(`/api/v2/patients/${this.fetch().authenticatedPatientId}/password`, { new_password: password });
  }

  generateUuid() {
    let d = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      /* eslint-disable no-bitwise */
      const r = (d + (Math.random() * 16)) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
      /* eslint-enable no-bitwise */
    });
  }

};



// WEBPACK FOOTER //
// ./main/services/session-service.js